import AutocompleteRegions from './AutocompleteRegions';

export default AutocompleteRegions;
export { AutocompleteRegions };
